// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__tZ0Ye"};